import React from 'react'
import Navbar from './Navbar'

function Blog() {
    return (
        <div>
           <Navbar/>
        </div>
    )
}

export default Blog
